import React, { FC } from "react";
import { observer } from 'mobx-react-lite';
import { TreeNode, TreeNodeLabel } from '../TreeNode';
import { InstructionNodeProps } from './InstructionNodeFactory';
import { LogInstruction } from '../../../../../machinelogic/types';

interface LogInstructionProps extends InstructionNodeProps {
  instruction: LogInstruction;
}

const getInstructionLabelName = (instruction: LogInstruction): string => {
  switch(instruction.name) {
    case 'console':
      const formattedMessage = instruction.parameters.message.replace(/`/g, '"');
      return `Message To Console ${instruction.parameters.level} ${formattedMessage}`;
    case 'url':
      return `Message To Url ${instruction.parameters.method} ${instruction.parameters.url} ${instruction.parameters.packMessage}`;
  }
};

export const LogNode: FC<LogInstructionProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const instructionLabel = <TreeNodeLabel
    icon="icon-start-chat flip-y"
    name={getInstructionLabelName(instruction)}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode title={instructionLabel} titleClassName={titleClassName} />
  );
});
